import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'mobx-react';
import * as Lib from './lib';
// import { RouteMain, pcStores, mStores, Loading } from '@weapp/layout';
import reportWebVitals from './reportWebVitals';
import { getLocale, weappSDK, appInfo } from "@weapp/utils";
import { dealImageUrl, getCookie, getQueryString, inPCClient, inWxWork, isPrivateEnv, isProOrBetaEnv } from "./utils";
import { Dialog } from '@weapp/ui';
import { LayoutSDK } from "./lib";
import { layoutPublicStatic } from "./constants";
const { confirm } = Dialog;
// document.title = `${window.weappTenantEnv?.urlTitle || 'eteams'}一体化的移动办公平台`;
const { RouteMain, pcStores, mStores, Loading } = Lib;

const stores = {
  ...pcStores,
  ...mStores
}
// 上线后需要把相关外部联系人代码都删除
// if (isProOrBetaEnv()) {
//   window.inExternalSpace = window.TEAMS?.currentUser?.type === 'external'
//     && window.location.href.indexOf("externalUserType") === -1 &&
//     window.location.href.indexOf("tenantKey") === -1;
//
//   if (window.localStorage?.getItem('inExternalSpace')) {
//     window.inExternalSpace = true;
//   }
// }

if (window.location.search.indexOf('testff') !== -1 ||
  (inWxWork() && window.location.pathname.indexOf('/ebdapp/') !== -1)) {
  window.hideEm = true;
}

if (window.location.search.indexOf('themePreview') !== -1) {
  window.inThemePreviewMode = true;
}

// 企业微信有些用户将整个ET作为整体应用配置，也是免登进入的，此时需要显示导航
const wxNavShow = getQueryString('shownavigation');
if (wxNavShow && wxNavShow === '1' && inWxWork()) {
  sessionStorage.setItem('wxNavShow', '1');
}




/* 路由根路径 */
export const root = appInfo('@weapp/layout').publicUrl;

if (root && window.location.pathname === '/') {
  window.location.href = root;
}

//给客户端提供E10页面标记
window.__ET_WEB_FLAG = true;

//更新favicon
if (window.TEAMS?.tenantLogo?.faviconUrl) {
  let url = window.TEAMS?.tenantLogo?.faviconUrl;

  if (url && (url.startsWith("http://") || url.startsWith("https://"))) {
    url = url.slice(url.indexOf("/api/file/noauth/"));
  }
  const { publicDomain, publicUrl } = appInfo('@weapp/layout');
  const publicUrlapi = window.publicUrlapi || window.publicUrl || '';
  if (url.indexOf('/static/img/') !== -1) {
    url = `${publicDomain}${publicUrl}/build/layout${url}`;
  }

  if (url.indexOf('/api/file') === 0) {
    url = `${publicUrlapi}${url}`
  }

  if (!url){
    url = isPrivateEnv() ?
      `${layoutPublicStatic}/static/img/global/ecology-favicon.ico` :
      `${layoutPublicStatic}/static/img/global/favicon.ico`
  }

  document.querySelector('link[rel="icon"]')?.setAttribute('href', dealImageUrl(url));
}

if (inPCClient()) {//pc客户端国际化传递
  try {
    getLocale('@weapp/passport').then((locale) => {
      weappSDK.ready(() => {
        if (weappSDK.customSDK.checkJsApi('getLangLabels')) {
          weappSDK.customSDK.invoke("getLangLabels", {
            success: (res: any) => {
              const labelObj = {} as any;
              (res?.langKeys || []).forEach((labelId: any) => {
                labelObj[labelId] = (locale?.labels || {})[labelId]
              })
              if (res?.langKeys?.length && weappSDK.customSDK.checkJsApi('setLangLabelInfo')) {
                const langTypeValue = getCookie('langType') || window.TEAMS?.locale?.lang;
                weappSDK.customSDK.invoke("setLangLabelInfo", {
                  localInfo: { type: langTypeValue, label: labelObj },
                  success: (respons: any) => {
                    console.log(respons)
                  }
                })
              }

            }
          })
        }
      })
    })
  } catch (error) {
    console.log(error)
  }

}

// const Comp=LayoutSDK.getMenusSetting().comp;
getLocale('@weapp/basicserver').then(() => {
  ReactDOM.render(
    <React.StrictMode weId={`cnc9eu`}>
      <Provider weId={`zyafoa`} {...stores}>
        <Router weId={`zbi4bj`}>
          <Route weId={`951zxy`} path={`${root}`}>
            <Suspense weId={`gqkp27`} fallback={<Loading weId={`iyx2ls`} />}>
              {/* <Comp weId={`${''}_rf5436`} menu={{id:"2225822942048321051"}}/> */}
              <RouteMain weId={`d9sm55`} />
            </Suspense>
          </Route>
        </Router>
      </Provider>
    </React.StrictMode >,
    document.getElementById('root')
  );
});

const timer = setTimeout(() => {
  window.weappLayout = Lib;
  // window.weappLayout.ebatchExport = false;
  clearTimeout(timer);
}, 0);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



/*
 * 默认应用本身按照 lib.js 进行 ESmodule 规范导出
 * 应用本页如果需要在全局获取自身的库（二开之类），虽然一般用不到，将被封装到 default 导出，和 lib 之间有差异
*/
// export default Lib;
